import type { ReactNode } from "react";

import { cn } from "@/shared/lib";
import { type Severity, SeverityDot } from "@/shared/ui/severity-dot";

const TILE_COLORS: Record<Severity, string> = {
  good: cn("border-good/40 bg-good/10"),
  warn: cn("border-warn/40 bg-warn/10"),
  bad: cn("border-bad/40 bg-bad/10"),
};

type SummaryTileProps = {
  severity: Severity;
  label: ReactNode;
  value: ReactNode;
  details?: ReactNode;
};

// Плитка сводки: цветная оценка, подпись, крупное значение и пояснение.
export const SummaryTile = ({ severity, label, value, details }: SummaryTileProps) => (
  <div
    data-severity={severity}
    className={cn(
      "flex min-h-[104px] flex-col gap-0.5 rounded-xl border px-4 py-3.5",
      TILE_COLORS[severity],
    )}
  >
    <span className="flex items-center gap-2.5">
      <SeverityDot severity={severity} />
      <span className="text-[13px] text-muted">{label}</span>
    </span>
    <span className="font-mono text-[26px] leading-tight font-semibold">{value}</span>
    {details !== undefined && <span className="text-[13px] text-muted">{details}</span>}
  </div>
);
